<template>
  <div class="homework__item active">
    <h3>Задания для битвы матриуса</h3>
    <ul class="homework__trains">
      <li
        v-for="item in items"
        :key="item.id"
        class="homework__train"
        :class="item.is_done == 1 ? 'homework__train--complete' : ''"
      >
        <div class="homework__base">
          <div class="homework__wrap">
            <div class="homework__content">
              <div class="homework__title">{{ item.trainer.title }}</div>
            </div>
            <div class="homework__button">
              <button @click="beginHomework(item)" :disabled="isDisabled(item)">
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["items", 'student_task_id'],
  methods: {
    isDisabled(item) {
      if (item.total >= item.qnt) {
        return true;
      }
      return false;
    },
    beginHomework(item) {
      let component = item.trainer.component;
      let params = item.params;

      let qnt = item.qnt;

      params.start = true;

      let data = {
        train: component + "_params",
        params: params,
      };
      this.$store.commit("train/changeParams", data);
      this.$router.push({
        name: "trainer",
        params: {
          component: component,
          trainer_id: item.trainer.id,
          params,
          is_matrius: true,
          student_task_id: this.student_task_id,
          qnt: qnt,
          total: item.total,
        },
      });
    },
  },
};
</script>
